import { Dropdown, Option } from '@fluentui/react-components';

type TProps = {
  value: string[];
  options: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  ariaLabel?: string;
  disabled?: boolean;
  className?: string;
};

// A plain (non-react-hook-form) multi-select dropdown for wizard-style local
// state. Forms that use react-hook-form use ControlledField instead.
export const MultiSelectDropdown = ({
  value,
  options,
  onChange,
  placeholder,
  ariaLabel,
  disabled,
  className,
}: TProps) => (
  <Dropdown
    multiselect
    disabled={disabled}
    className={className}
    aria-label={ariaLabel}
    placeholder={placeholder}
    selectedOptions={value}
    value={value.join(', ')}
    onOptionSelect={(_, data) => onChange(data.selectedOptions)}
  >
    {options.map((option) => (
      <Option key={option} value={option} text={option}>
        {option}
      </Option>
    ))}
  </Dropdown>
);
